<ng-container [ngTemplateOutlet]="isCompactLayout()?.matches ? mobileTpl : desktopTpl"></ng-container>

<ng-template #desktopTpl>
    <div class="controls-container desktop" data-testid="player_controls-desktop">
        <div class="flex">
            <div class="title">
                <h2 class="font-xxlarge" data-testid="player_title">{{itemTitle()}}</h2>
            </div>
        </div>
        <div class="flex">
            <div class="flex">
                <rounded-icon-button class="control relative" [size]="'large'"
                    [transparentBackground]="true" [imgSrc]="skinning.getImage(isPlaying()?'icon_pause':'icon_play')"
                    [attr.data-testid]="isPlaying() ? 'player_pause' : 'player_play'"
                    (onClick)="isPlaying()?onPause():onPlay()" [disabled]="isPlaying() && !isPauseEnabled()"></rounded-icon-button>
                @if(isSeekEnabled()){
                @if(isRestartEnabled()){
                <rounded-icon-button class="control relative" [size]="'large'"
                    [transparentBackground]="true" [imgSrc]="skinning.getImage('icon_start_over')"
                    data-testid="player_start-over" (onClick)="onReplay()"></rounded-icon-button>
                }
                @if(isHistoricEpgEnabled()){
                <rounded-icon-button class="control relative" [size]="'large'"
                    [transparentBackground]="true" [imgSrc]="skinning.getImage('icon_play_backward')"
                    data-testid="player_seek-backward" (onClick)="setSeek(-10)"></rounded-icon-button>
                }
                <rounded-icon-button class="control relative" [size]="'large'"
                    [transparentBackground]="true" [imgSrc]="skinning.getImage('icon_play_forward')"
                    data-testid="player_seek-forward" (onClick)="setSeek(10)" [disabled]="isLive()"></rounded-icon-button>
                @if(isCurrentItemLive()){
                <rounded-icon-button class="control relative" [size]="'large'" data-testid="player_live"
                    [transparentBackground]="true" [imgSrc]="skinning.getImage('icon_live')" (click)="onLive()"
                    [imgColor]="isLive() ? skinning.getRootVariableValue('--exclamation') : skinning.getRootVariableValue('--text_secondary')"
                    [text]="(isLive() ? 'player.live' : 'player.controls.return_to_live') | transloco"
                    [textWidth]="80">
                </rounded-icon-button>
                }
                }
            </div>
            @if(isCurrentItemLive()){
            @if(isSeekEnabled()){
            <div class="time">
                <span>{{ liveProgress() - liveTimeStart() | date:'HH:mm:ss':'UTC' }}</span>
            </div>
            }
            <div class="timeline-container">
                @if(liveTimeStart() && liveTimeEnd() && isSeekEnabled()){
                <p-slider class="timeline" data-testid="player_seek-bar" [ngModel]="liveProgress()" [min]="liveSeekMin()" [max]="liveTimeEnd()"
                    (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
                    (pointerdown)="$event.stopPropagation()" (mousemove)="onSeekHover($event)"
                    (mouseleave)="onSeekClearHover()" (ngModelChange)="onSeekLive($event)"></p-slider>
                }
            </div>
            @if(isSeekEnabled()){
            <div class="time">
                <span>{{ liveTimeEnd() - liveProgress() | date:'HH:mm:ss':'UTC' }}</span>
            </div>
            }
            }@else {
            <div class="time">
                <span>{{ (progress() * 1000 ) | date:'HH:mm:ss':'UTC' }}</span>
            </div>
            <div class="timeline-container">
                <p-slider class="timeline" data-testid="player_seek-bar" [ngModel]="progress()" [max]="seekMax()"
                    (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
                    (pointerdown)="$event.stopPropagation()" (mousemove)="onSeekHover($event)"
                    (mouseleave)="onSeekClearHover()" (ngModelChange)="onSeek($event)"></p-slider>
            </div>
            <div class="time">
                <span>{{ ((duration() - progress()) * 1000 ) | date:'HH:mm:ss':'UTC'}}</span>
            </div>
            }
            <div class="flex">
                @if(isSeries()){
                <div class="seasons-episodes-container">
                    <player-controls-series-episodes #episodesComponent></player-controls-series-episodes>
                    <rounded-icon-button class="control relative" [size]="'large'"
                        [transparentBackground]="true" data-testid="player_series-menu"
                        [imgSrc]="skinning.getImage('icon_seasons')"
                        (mouseenter)="episodesComponent.scrollToActive()"></rounded-icon-button>
                </div>
                }
                <div class="volume-container">
                    <div class="volume-component">
                        <div class="slider-wrapper">
                            <p-slider class="volume" data-testid="player_volume-bar" [ngModel]="volume()" [max]="100" (ngModelChange)="onVolume($event)"
                                (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
                                (pointerdown)="$event.stopPropagation()" orientation="vertical"></p-slider>
                        </div>
                    </div>
                    <rounded-icon-button class="control relative" [size]="'large'"
                        [transparentBackground]="true" data-testid="player_volume"
                        [imgSrc]="skinning.getImage(isMuted()?'icon_sound_off':'icon_sound_on')"
                        (onClick)="toggleMute()"></rounded-icon-button>
                </div>

                <div class="settings-container">
                    <player-controls-settings #settingsMenu [minSpeed]="minSpeed()" [maxSpeed]="maxSpeed()"></player-controls-settings>
                    @if (settingsMenu.menus().length) {
                    <rounded-icon-button class="control relative" [size]="'large'"
                        [transparentBackground]="true" data-testid="player_settings"
                        [imgSrc]="skinning.getImage('icon_tile_settings')"></rounded-icon-button>
                    }
                </div>
                <rounded-icon-button class="control relative" [size]="'large'"
                    [transparentBackground]="true" [imgSrc]="skinning.getImage('icon_PiP')"
                    data-testid="player_pip-enter" (onClick)="togglePip()"></rounded-icon-button>
                <rounded-icon-button class="control relative" [size]="'large'"
                    [transparentBackground]="true"
                    [imgSrc]="skinning.getImage(isFullscreen()?'icon_fullscreen_exit':'icon_fullscreen_enter')"
                    [attr.data-testid]="isFullscreen() ? 'player_fullscreen-exit' : 'player_fullscreen-enter'"
                    (onClick)="toggleFullscreen()"></rounded-icon-button>
            </div>
        </div>
    </div>

    @if(thumbnailConfig()){
    <player-controls-seek-preview [seekPosition]="seekPosition()" [thumbnailConfig]="thumbnailConfig()"
        [style.left.px]="cursorPosition()"></player-controls-seek-preview>
    }
</ng-template>

<ng-template #mobileTpl>
    <div class="controls-container mobile" data-testid="player_controls-compact">
        @if(isCurrentItemLive()){
        @if(isSeekEnabled()){
        <div class="timeline-container">
            @if(liveTimeStart() && liveTimeEnd()){
            <p-slider class="timeline" data-testid="player_seek-bar" [ngModel]="liveProgress()" [min]="liveSeekMin()" [max]="liveTimeEnd()"
                (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
                (pointerdown)="$event.stopPropagation()" (mousemove)="onSeekHover($event)"
                (mouseleave)="onSeekClearHover()" (ngModelChange)="onSeekLive($event)"></p-slider>
            }
        </div>
        <div class="flex justify-between">
            <div class="time">
                <span>{{ (liveTimeStart()) | date:'HH:mm:ss' }}</span>
            </div>
            <div class="time">
                <span>{{ liveTimeEnd() | date:'HH:mm:ss'}}</span>
            </div>
        </div>
        }

        }@else {
        <div class="timeline-container">
            <p-slider class="timeline" data-testid="player_seek-bar" [ngModel]="progress()" [max]="seekMax()" (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()"
                (mousemove)="onSeekHover($event)" (mouseleave)="onSeekClearHover()"
                (ngModelChange)="onSeek($event)"></p-slider>
        </div>
        <div class="flex justify-between">
            <div class="time">
                <span>{{ (progress() * 1000 ) | date:'HH:mm:ss':'UTC' }}</span>
            </div>
            <div class="time">
                <span>{{ (duration() * 1000 ) | date:'HH:mm:ss':'UTC'}}</span>
            </div>
        </div>
        }
        <div class="flex justify-between">
            <rounded-icon-button class="control relative" [size]="'small'" [transparentBackground]="true"
                [imgSrc]="skinning.getImage(isPlaying()?'icon_pause':'icon_play')"
                [attr.data-testid]="isPlaying() ? 'player_pause' : 'player_play'"
                (onClick)="isPlaying()?onPause():onPlay()" [disabled]="isPlaying() && !isPauseEnabled()"></rounded-icon-button>
            @if(isSeekEnabled()){
            @if(isRestartEnabled()){
            <rounded-icon-button class="control relative" [size]="'small'" [transparentBackground]="true"
                [imgSrc]="skinning.getImage('icon_start_over')" data-testid="player_start-over"
                (onClick)="onReplay()"></rounded-icon-button>
            }
            @if(isHistoricEpgEnabled()){
            <rounded-icon-button class="control relative" [size]="'small'" [transparentBackground]="true"
                [imgSrc]="skinning.getImage('icon_play_backward')" data-testid="player_seek-backward"
                (onClick)="setSeek(-10)"></rounded-icon-button>
            }
            <rounded-icon-button class="control relative" [size]="'small'" [transparentBackground]="true"
                [imgSrc]="skinning.getImage('icon_play_forward')" data-testid="player_seek-forward"
                (onClick)="setSeek(10)" [disabled]="isLive()"></rounded-icon-button>
            }

            <div class="volume-container">
                <div class="volume-component">
                    <div class="slider-wrapper">
                        <p-slider class="volume" data-testid="player_volume-bar" [ngModel]="volume()" [max]="100" (ngModelChange)="onVolume($event)"
                            (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
                            (pointerdown)="$event.stopPropagation()" orientation="vertical"></p-slider>
                    </div>
                </div>
                <rounded-icon-button class="control relative" [size]="'small'"
                    [transparentBackground]="true" data-testid="player_volume"
                    [imgSrc]="skinning.getImage(isMuted()?'icon_sound_off':'icon_sound_on')"
                    (onClick)="toggleMute()"></rounded-icon-button>
            </div>

            <div class="settings-container">
                <player-controls-settings #settingsMenu [minSpeed]="minSpeed()" [maxSpeed]="maxSpeed()"></player-controls-settings>
                @if (settingsMenu.menus().length) {
                <rounded-icon-button class="control relative" [size]="'small'"
                    [transparentBackground]="true" data-testid="player_settings"
                    [imgSrc]="skinning.getImage('icon_tile_settings')"></rounded-icon-button>
                }
            </div>
            <rounded-icon-button class="control relative" [size]="'small'" [transparentBackground]="true"
                [imgSrc]="skinning.getImage('icon_PiP')" data-testid="player_pip-enter"
                (onClick)="togglePip()"></rounded-icon-button>
            <rounded-icon-button class="control relative" [size]="'small'" [transparentBackground]="true"
                [imgSrc]="skinning.getImage(isFullscreen()?'icon_fullscreen_exit':'icon_fullscreen_enter')"
                [attr.data-testid]="isFullscreen() ? 'player_fullscreen-exit' : 'player_fullscreen-enter'"
                (onClick)="toggleFullscreen()"></rounded-icon-button>
        </div>
        <div class="flex justify-center">
            @if(isSeries()){
            <div class="seasons-episodes-container">
                <player-controls-series-episodes #episodesComponentMobile></player-controls-series-episodes>
                <rounded-icon-button class="control relative" [size]="'small'"
                    [transparentBackground]="true" data-testid="player_series-menu"
                    [imgSrc]="skinning.getImage('icon_seasons')"
                    (mouseenter)="episodesComponentMobile.scrollToActive()"></rounded-icon-button>
            </div>
            }
            @if(isCurrentItemLive() && isSeekEnabled()){
            <rounded-icon-button class="control relative" [size]="'small'" [transparentBackground]="true" data-testid="player_live"
                [imgSrc]="skinning.getImage('icon_live')" (click)="onLive()"
                [imgColor]="isLive() ? skinning.getRootVariableValue('--exclamation') : skinning.getRootVariableValue('--text_secondary')"
                [text]="(isLive() ? 'player.live' : 'player.controls.return_to_live') | transloco"
                [textWidth]="80">
            </rounded-icon-button>
            }
        </div>
    </div>

    @if(thumbnailConfig()){
    <player-controls-seek-preview [seekPosition]="seekPosition()" [thumbnailConfig]="thumbnailConfig()"
        [style.left.px]="cursorPosition()"></player-controls-seek-preview>
    }
</ng-template>
